export default (text, fontSize = 14, fontWeight = 400) => {
  // server side rendering
  if (typeof document === 'undefined') return 0;

  const context = document.createElement('canvas').getContext('2d');
  context.font = `${fontWeight} ${fontSize}px Artifakt Element`;
  text = text.trim();
  return context.measureText(text).width;
};
